// ===========================================================================
//  Roadmap "Tu Camino hacia la Autorización" — pulso de luz (GSAP).
//  · Un pulso cian aparece fuerte en el 01 y recorre la línea hasta pasar
//    el 05, desvaneciéndose al final. En bucle lento (~8 s) con una pausa
//    entre pasadas. NO atado al scroll.
//  · Pasa POR DEBAJO de los círculos (z-index en CSS). Los círculos no se
//    encienden: solo viaja el pulso.
//
//  Rendimiento: por frame solo transform/opacity → GPU. Geometría medida
//  una vez por pasada (onRepeat) / resize, nunca por frame. Pausado fuera
//  de pantalla (IntersectionObserver).
//
//  Progressive enhancement: sin GSAP o con reduced-motion no hay pulso.
//
//  NOTA Turbo: Academia se llega por navegación de *frame* (menú con
//  data-turbo-frame), que dispara turbo:frame-render/-load y NO
//  turbo:load. Por eso los escuchamos (ver DEV_NOTES §7).
// ===========================================================================
(function () {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var active = false;
    var io = null;
    var tl = null;
    var onResize = null;

    function gsapReady() {
        return typeof window.gsap !== 'undefined';
    }

    function kill() {
        if (io) { try { io.disconnect(); } catch (e) {} io = null; }
        if (tl) { try { tl.kill(); } catch (e) {} tl = null; }
        if (onResize) { window.removeEventListener('resize', onResize); onResize = null; }
        active = false;
    }

    function run() {
        if (!gsapReady()) return;

        var section = document.querySelector('.roadmap-section');
        if (!section) return; // no estamos en la página con roadmap

        var timeline = section.querySelector('.roadmap-timeline');
        var lineEl = section.querySelector('.roadmap-line');
        var pulse = section.querySelector('.roadmap-pulse');
        var markers = Array.prototype.slice.call(section.querySelectorAll('.step-marker'));
        if (!timeline || !lineEl || !pulse || markers.length < 2) return;

        kill();
        active = true;
        document.documentElement.classList.add('gsap-on');
        var gsap = window.gsap;

        if (prefersReduced) { gsap.set(pulse, { autoAlpha: 0 }); return; } // sin pulso

        var a = { x: 0, y: 0 }, b = { x: 0, y: 0 };
        var pw = pulse.offsetWidth || 16, ph = pulse.offsetHeight || 16;

        // El pulso viaja SOBRE el eje de la propia línea (no en el centro de
        // los círculos, que queda un poco más abajo). En el eje de recorrido
        // va del primer al último marcador, extendido un 6% para "pasar" el 05.
        function measure() {
            var tr = timeline.getBoundingClientRect();
            var lr = lineEl.getBoundingClientRect();
            var m0 = markers[0].getBoundingClientRect();
            var mn = markers[markers.length - 1].getBoundingClientRect();
            var horizontal = lr.width >= lr.height;
            if (horizontal) {
                var ly = lr.top - tr.top + lr.height / 2;          // eje Y de la línea
                var x0 = m0.left - tr.left + m0.width / 2;
                var xn = mn.left - tr.left + mn.width / 2;
                a = { x: x0, y: ly };
                b = { x: x0 + (xn - x0) * 1.06, y: ly };
            } else {
                var lx = lr.left - tr.left + lr.width / 2;          // eje X de la línea
                var y0 = m0.top - tr.top + m0.height / 2;
                var yn = mn.top - tr.top + mn.height / 2;
                a = { x: lx, y: y0 };
                b = { x: lx, y: y0 + (yn - y0) * 1.06 };
            }
            pw = pulse.offsetWidth || pw;
            ph = pulse.offsetHeight || ph;
        }

        function place(p) {
            var cx = a.x + (b.x - a.x) * p;
            var cy = a.y + (b.y - a.y) * p;
            gsap.set(pulse, { x: cx - pw / 2, y: cy - ph / 2 });
        }

        measure();
        place(0);

        var DUR = 10;     // recorrido lento
        var PEAK = 0.75;  // brillo máximo (sutil, no distrae)
        var proxy = { p: 0 };
        tl = gsap.timeline({
            repeat: -1,
            repeatDelay: 1.3,
            paused: true,
            onRepeat: function () { measure(); place(0); }
        });
        tl.set(proxy, { p: 0 }, 0);
        // recorre la línea, lento
        tl.to(proxy, { p: 1, duration: DUR, ease: 'sine.inOut', onUpdate: function () { place(proxy.p); } }, 0);
        // brillo CRECIENTE: arranca apagado en el 01 y sube de forma continua
        // (ya notable a media línea) hasta el pico en la meta (05).
        tl.fromTo(pulse,
            { autoAlpha: 0.1 },
            { autoAlpha: PEAK, duration: DUR * 0.88, ease: 'none' }, 0);
        // en la meta se apaga limpio, para reiniciar el bucle.
        tl.to(pulse, { autoAlpha: 0, duration: DUR * 0.12, ease: 'power2.in' }, DUR * 0.88);

        onResize = function () { measure(); place(proxy.p); };
        window.addEventListener('resize', onResize);

        // Solo corre cuando la sección está en pantalla.
        if ('IntersectionObserver' in window) {
            io = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (e.isIntersecting) tl.play();
                    else tl.pause();
                });
            }, { threshold: 0.4 });
            io.observe(timeline);
        } else {
            tl.play();
        }
    }

    // Re-ejecución con debounce: varios eventos de frame pueden encadenarse.
    var pending = null;
    function schedule() {
        if (pending) clearTimeout(pending);
        pending = setTimeout(run, 80);
    }

    // Disparadores: carga inicial + ciclo de vida de Turbo (incluida la
    // navegación de frame del menú — ver DEV_NOTES §7).
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
    document.addEventListener('turbo:load', run);
    document.addEventListener('turbo:frame-render', schedule);
    document.addEventListener('turbo:frame-load', schedule);
    document.addEventListener('turbo:before-render', function () { if (active) kill(); });
})();
